export const fondosCesantias = [
  { value: 'COLFONDOS', label: 'COLFONDOS' },
  { value: 'SKANDIA', label: 'SKANDIA' },
  { value: 'PORVENIR', label: 'PORVENIR' },
  { value: 'PROTECCION', label: 'PROTECCION' },
  { value: 'FONDO NACIONAL DEL AHORRO', label: 'FONDO NACIONAL DEL AHORRO' },
];
